import { EmailAuthProvider, browserLocalPersistence, browserSessionPersistence, fetchSignInMethodsForEmail, getAuth, onAuthStateChanged, setPersistence, signInWithEmailAndPassword } from 'firebase/auth';
import { addListnerForAuthStateVisibility, initFirebase } from "./utils/fbase";
import { toast } from "bulma-toast"
import { handleTelInputs, redirectAfterSignin } from './utils/helper-functions';
import { OAuthStrategy, createClient } from '@wix/api-client';
import { getFunctions, httpsCallable } from 'firebase/functions';

initFirebase()

onAuthStateChanged(getAuth(), (user) => {
    if (user) redirectAfterSignin()
})

document.addEventListener('DOMContentLoaded', () => {
    console.log("DOMContentLoaded")
    console.log(process.env.FBASE_APP_ID)

    addListnerForAuthStateVisibility()
    handleTelInputs()

    const section_signin = document.getElementById('section_signin')
    const section_create_account = document.getElementById('section_create_account')
    const form_signin = document.getElementById('form_signin')
    const form_create_account = document.getElementById('form_create_account')
    let authStatePersistence = browserSessionPersistence
    const auth = getAuth()

    form_signin.addEventListener('submit', async (ev) => {
        ev.preventDefault()
        const form = ev.target

        const email = form.signin_email.value
        const password = form.signin_password.value
        

        form.submit.classList.add('is-loading')

        const providers = await fetchSignInMethodsForEmail(auth, email)

        if (providers.includes(EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD)) {

            if (form.keep_signed_in.checked) authStatePersistence = browserLocalPersistence

            setPersistence(auth, authStatePersistence)
                .then(() => signInWithEmailAndPassword(auth, email, password))
                .then(userCredential => {
                    const user = userCredential.user
                    console.info("Firebase: Existing user sign in.", user.uid)
                    form.submit.classList.remove('is-loading')
                    redirectAfterSignin()
                })
                .catch(error => {
                    toast({
                        type: 'is-danger',
                        dismissible: true,
                        position: 'top-center',
                        message: 'Invalid credentials! Please, try again with correct details or try creating a new account.'
                    })
                    form.submit.classList.remove('is-loading')
                    console.error("Firebase: Could not sign in.", error)
                })
        }
        else {
            const wixClientB2B = createClient({
                auth: OAuthStrategy({
                    clientId: process.env.WIX_CLIENT_ID_B2B
                })
            })

            wixClientB2B.auth.login({
                email: email,
                password: password
            })
                .then((response) => {
                    if (response.loginState === 'SUCCESS') {
                        const sessionToken = response.data.sessionToken
                        const getDataForWixUser = httpsCallable(getFunctions(), 'getDataForWixUser')
                        return getDataForWixUser({
                            email: email,
                            sessionToken: sessionToken
                        })
                    }
                    else return {}
                })
                .then(response => {
                    const userData = response.data
                    if (userData.hasOwnProperty('email') && userData.email === email) {
                        form.submit.classList.remove('is-loading')

                        form_create_account['email'].value = userData.email || ''
                        form_create_account['password'].value = password || ''
                        form_create_account['name'].value = userData.name || ''
                        form_create_account['compnay_name'].value = userData.compnay_name || ''
                        form_create_account['location-input'].value = userData.address_line1 || ''
                        form_create_account['street_number-input'].value = userData.address_line2 || ''
                        form_create_account['locality-input'].value = userData.address_city || ''
                        form_create_account['administrative_area_level_1-input'].value = userData.address_state || ''
                        form_create_account['country-input'].value = userData.address_country || ''
                        form_create_account['postal_code-input'].value = userData.address_postal_code || ''
                        form_create_account['telephone_no'].value = userData.telephone_no || ''

                        section_signin.classList.add('is-hidden')
                        section_create_account.classList.remove('is-hidden')


                    }
                    else {
                        toast({
                            type: 'is-danger',
                            dismissible: true,
                            position: 'top-center',
                            message: 'Invalid credentials! Please, try again with correct details or try creating a new account.'
                        })
                        form.submit.classList.remove('is-loading')
                        console.error("Wix B2B: Could not sign in.")
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        }
    })

    form_create_account.addEventListener('submit', async (ev) => {
        ev.preventDefault()
        const form = ev.target

        form.submit.classList.add('is-loading')
        const createUserAccount = httpsCallable(getFunctions(), 'createUserAccount')

        createUserAccount({
            email: form['email'].value || '',
            password: form['password'].value || '',
            name: form['name'].value || '',
            compnay_name: form['compnay_name'].value || '',
            address_line1: form['location-input'].value || '',
            address_line2: form['street_number-input'].value || '',
            address_city: form['locality-input'].value || '',
            address_state: form['administrative_area_level_1-input'].value || '',
            address_country: form['country-input'].value || '',
            address_postal_code: form['postal_code-input'].value || '',
            telephone_no: form['telephone_no'].value || ''
        })
        .then(() => setPersistence(auth, authStatePersistence))
            .then(() => signInWithEmailAndPassword(auth, form['email'].value, form['password'].value))
            .then(() => {
                redirectAfterSignin()
            })
            .catch(error => {
                toast({
                    type: 'is-danger',
                    dismissible: true,
                    position: 'top-center',
                    message: 'Some error occurred! Please, try again after some time or contact us.'
                })
                form.submit.classList.remove('is-loading')
                console.error("Firebase: Could not create account.", error)
            })

    })


    try {
        const btn_signout_el = document.getElementById('btn_signout')
        btn_signout_el.addEventListener('click', () => {
            btn_signout_el.classList.add('is-loading')
            handleSignOut()
            btn_signout_el.classList.remove('is-loading')
        })
    } catch (error) {
        console.error("App: Could not add click event listner to #btn_signout.", error)
    }

})